<template>
  <table class="table">
    <thead>
      <th class="align-middle">Plik {{filesFiltered.length}}</th>
      <th v-if="hasFileDescription" class="align-middle">Opis</th>
      <th
        class="action-cell text-center align-middle"
        :style="`width: ${hasFileDescription ? 190 : 140}px;`">
        Akcja
      </th>
    </thead>
    <tbody :key="filesFiltered.length">
      <tr
        v-for="(file, fileIndex) in filesFiltered"
        :key="`file${fileIndex}-${filesType}`">
        <td class="align-middle">
          <span v-if="file.filename">
            {{ file.filename }}
          </span>
          <span v-else>
            {{ file.file? file.file.name : '' }}
          </span>
        </td>
        <td
          v-if="hasFileDescription"
          class="align-middle">
          {{ file.description }}
        </td>
        <td class="text-center align-middle">
          <d-button
            v-if="hasFileDescription"
            theme="primary"
            outline
            title="Edytuj"
            class="mx-1 my-1"
            @click.prevent="$emit('editFile', file, fileIndex, filesType)">
            <i class="material-icons" style="left: -2px">edit</i>
          </d-button>
          <d-button
            theme="danger"
            outline
            title="Usuń"
            class="mx-1 my-1"
            @click.prevent="$emit('removeFile', file, fileIndex, filesType)">
            <i class="material-icons" style="left: -2px">delete</i>
          </d-button>
          <d-button
            v-if="file.filename"
            outline
            title="Pobierz"
            class="mx-1 my-1"
            @click.prevent="$emit('downloadFile', file)">
            <i class="material-icons" style="left: -2px">download</i>
          </d-button>
        </td>
      </tr>
      <tr v-if="!filesFiltered.length">
        <td
          :colspan="hasFileDescription ? 3 : 2"
          class="text-info text-center">
          Nie załączono plików
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'GuaranteeFormFilesColumn',
  props: {
    filesList: {
      default: () => [],
      type: Array
    },
    filesType: {
      default: '',
      type: String
    },
    hasFileDescription: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    filesFiltered () {
      if (!this.filesList.length) {
        return [];
      }

      return this.filesList.filter(item => item.type === this.filesType || (item.type === '' && this.filesType === 'other_files'));
    }
  }
}

</script>
